/**
 * Sports Realm — testimonial rotator.
 * Mirrors the mockup: autoplay (default 5500ms), prev/next, pause on hover,
 * re-arm after interaction, honours prefers-reduced-motion. No dependencies.
 */
(function () {
  'use strict';
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.srTestiReady === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sr-testi-slide]'));
    if (slides.length < 2) { root.dataset.srTestiReady = 'true'; return; }

    var prev = root.querySelector('[data-sr-testi-prev]');
    var next = root.querySelector('[data-sr-testi-next]');
    var delay = parseInt(root.dataset.autoplaySpeed, 10) || 5500;
    var index = 0;
    var timer = null;

    function go(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('sr-is-active', on);
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
    }
    function arm() {
      if (timer) clearInterval(timer);
      if (!REDUCE) timer = setInterval(function () { go(index + 1); }, delay);
    }

    if (next) next.addEventListener('click', function () { go(index + 1); arm(); });
    if (prev) prev.addEventListener('click', function () { go(index - 1); arm(); });
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', arm);
    root.addEventListener('focusin', function () { if (timer) clearInterval(timer); });
    root.addEventListener('focusout', arm);

    root.dataset.srTestiReady = 'true';
    go(0);
    arm();
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-sr-testi]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
